// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"c2-z","subtitle":"d2-z","wrapper":"e2-z","leftArrow":"f2-z","rightArrow":"g2-z"};